import React from "react";
import PropTypes from "prop-types";

import { ViewEditIcon } from "../../utils/Icons";

const ViewEditButton = ({
  containerClassName,
  className,
  onClick,
  label
}) => {
  return (
    <div
      className={`${containerClassName} pointer bg-white padding-10 border-radius-8 primary-hover primary-border-sm edit-btn ${label ? "d-flex - gap-2" : ""}`}
      onClick={onClick}>
      <ViewEditIcon
        className={`table-icon action-icon  ${className}`}
      />
      <span className="text-primary fweight-500 fsize-16 d-none d-md-block">
        {label}
      </span>
    </div>
  );
};

ViewEditButton.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string
};

export default ViewEditButton;
